import Course from '@/models/Course.js';
import Model from '@/models/Model.js';
import User from '@/models/User.js';

export default class DiscussionReply extends Model {
    static entity = 'discussion_replies';

    static fields() {
        return {
            id: this.attr(null),
            activity_id: this.attr(null),
            body: this.attr(null),
            created_at: this.attr(null),
            deleted_at: this.attr(null),
            thread_id: this.attr(null),
            updated_at: this.attr(null),
            type: this.string('Discussion Reply'),

            user: this.belongsTo(User, 'user_id'),
            course: this.belongsTo(Course, 'course_id'),
        };
    }
}
